import { render, staticRenderFns } from "./commerce-connector-cta.vue?vue&type=template&id=d64d1a38"
import script from "./commerce-connector-cta.vue?vue&type=script&lang=js"
export * from "./commerce-connector-cta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports